import Item from 'common/ITEMS/Item';

const items = {
  //region Beast Mastery
  //endregion
  //region Marksmanship
  //endregion
  //region Survival
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
